/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,.' + accBtn + '-close,#overlay,#header').toggleClass('active')
  })

  // スクロールナビゲーション
  const fps = 10 // FPS設定 60まで上げるとほとんど負荷低減効果がなくなる
  const frameTime = 1000 / fps
  let isScroll = false // スクロールフラグ
  let scrollY = 0 // 縦方向のスクロール量
  let changePoint = 0
  if ($(window).width() > 768) {
    if (window.pageYOffset > changePoint) {
      $('#header').addClass('scrolled')
    }
    document.addEventListener('scroll', function(ev) {
      // スクロール量の更新だけを行う
      scrollY = window.pageYOffset // スクロール量更新
      isScroll = true // フラグON
    })
    scrollNav()
  }
  function scrollNav() {
    // スクロールフラグが立っているときだけDOM書き換え
    if (isScroll) {
      if (scrollY > changePoint) {
        $('#header').addClass('scrolled')
      } else {
        $('#header').removeClass('scrolled')
      }
      isScroll = false // フラグをOFFに戻す
      // console.log('Action:' + ++actionCount)
    }
    setTimeout(scrollNav, frameTime) // 次回の処理を登録
  }

  // UserAgent判定
  const userAgent = window.navigator.userAgent.toLowerCase()
  let isIE = false
  let isMobile = false
  if(userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1 || userAgent.indexOf('edge') !== -1) {
    // IE・Edgeからのアクセス
    isIE = true
  } else if(userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1 || userAgent.indexOf('android') !== -1) {
    // モバイル端末からのアクセス
    isMobile = true
  }

  if(isMobile) {
    //モバイルアクセス時、電話番号に<a href="tel:～追加
    const phoneNoArr = $('.js-sp-phone').text().split('-')
    let phoneNo = ''
    phoneNoArr.forEach(function(no) {
      phoneNo = phoneNo + no
    })
    $('.js-sp-phone').wrap('<a href="tel:' + phoneNo + '" />')
  }

  // MVページネーション
  $('.mv__bar').on('click', function() {
    const index = $(this).index()
    const text = $('.mv-slide.now').children('.mv__text--header')
    window.clearInterval(mvAnime)
    $(this).siblings().removeClass('now')
    $(this).addClass('now')
    // 画像切替
    if (index === 0) {
      $('.mv__clip--base .bg').addClass('active')
    } else {
      $('.mv__clip--base .bg').removeClass('active')
    }
    $('#mv_top').animate({left: intervalSize * (index - 1) * -1}, 800, 'easeOutExpo')
    $('#mv_bottom').animate({left: endpoint + intervalSize * index}, 800, 'easeOutExpo')
    // テキスト切替
    $('.mv-slide').removeClass('now')
    $('.mv-slide').eq(index).addClass('now')
    animationMVText(text)
  })

  // MVアニメーション
  const mvAnimationIntarval = 5000
  const intervalSize = $('#mv_top').width() / 4
  const endpoint = intervalSize * -4
  let mvAnime
  function animateMV() {
    // テキスト部分の処理
    const nowSlide = $('.mv-slide.now')
    const nowBar = $('.mv__bar.now')
    const index = nowBar.next().index()
    if (nowSlide.next().length) {
      const text = nowSlide.next().children('.mv__text--header')
      nowSlide.next().addClass('now')
      nowSlide.removeClass('now')
      nowBar.next().addClass('now')
      nowBar.removeClass('now')
      animationMVText(text)
    } else {
      nowSlide.siblings().first().addClass('now')
      nowSlide.removeClass('now')
      nowBar.siblings().first().addClass('now')
      nowBar.removeClass('now')
    }

    // 画像部分の処理
    if (index < 0) {
      $('.mv__clip--base .bg').addClass('active')
    } else {
      $('.mv__clip--base .bg').removeClass('active')
    }
    $('#mv_top').animate({left: intervalSize * (index - 1) * -1}, 800, 'easeOutExpo')
    $('#mv_bottom').animate({left: endpoint + intervalSize * index}, 800, 'easeOutExpo')
  }

  // 文字を1文字ずつ表示
  function animationMVText(text) {
    text.children().css('opacity', '0')
    let char = text.children(':first-child')
    let delay = 0
    while (char.length) {
      char.delay(delay)
      char.animate({opacity: 1}, 500)
      delay = delay + 100
      char.delay(delay)
      char = char.next()
    }
  }

  // News記事一覧タブ
  $('.js-tab-content-item').hide()
  $($('.js-tab a.active').attr('href')).show()
  $('.js-tab a').on('click', function() {
    if(!$(this).hasClass('active')) {
      $(this).addClass('active')
      $(this).parent().siblings().children('a').removeClass('active')
      const showTab = $($(this).attr('href'))
      showTab.show()
      showTab.siblings().hide()
    }
    return false
  })

  // Trunk8
  function trunk8() {
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }
  if ($('.js-t8')[0]) {
    // 要素を検出したら実行
    trunk8()
    $('.js-t8').removeAttr('title')
    $(window).on('load resize ', function() {
      trunk8()
      $('.js-t8').removeAttr('title')
    })
  }

  /* eslint-disable */
  if ($('#mv_top').length) {
    if(isIE || isMobile) {
      // IE, Edge, モバイルの時はSwiperによるスライド
      $('.mv').hide()
      $('.mv-ms').show()
      const mvSwiper = new Swiper('.mv-swiper-container', {
        autoplay: {
          delay: mvAnimationIntarval
        },
        effect: 'fade',
        speed: 1000,
        loop: true,
        pagination: {
          el: '.mv-swiper-container .swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      })
    } else {
      // その他の時
      mvAnime = window.setInterval(animateMV, mvAnimationIntarval)
    }
  }
  const tickerSwiper = new Swiper('.ticker-swiper-container', {
    autoplay: {
      delay: 3000
    },
    direction: 'vertical',
    loop: true,
    autoHeight: true,
  })

  // 会社案内スライド
  if ($('.l-company-env__slide').length) {
    const companySwiper = new Swiper('.l-company-env__slide', {
      effect: 'slide',
      speed: 1000,
      loop: true,
      pagination: {
        el: '.l-company-env__slide + .swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.l-company-env__slide .swiper-button-next',
        prevEl: '.l-company-env__slide .swiper-button-prev',
      },
    })
  }
  /* eslint-enable */
})
